import { FC } from 'react'

import { Tools } from '../tools/setup'

const ToolComponents = () => {
  const toolsComponents = Tools.map((tool) => tool.components?.editor)
    .flat()
    .filter((component) => !!component) as FC[]

  return toolsComponents.map((ToolComponent) => (
    <ToolComponent key={`blueprint-editor-tool-component-${ToolComponent.name}`} />
  ))
}

export default ToolComponents
